import PropTypes from "prop-types";
import React, { Suspense, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom/es";
import { Notifs } from "redux-notifications";
import { Banner } from "signoxe/components/layout/Page";
import {
  fetchAll,
  fetchPagedAssets,
  logoutUser,
  markAllNotificationsRead,
  toggleHelp,
  toggleUploadsTray,
  toggleUploadType,
} from "signoxe/actions";
import {
  ConfirmationPopup,
  ErrorBoundary,
  HelpMessageRoutes,
  NotificationMessage,
  UploadTray,
  UploadDispatch,
  TagsPopup,
  BulkConfirmationPopup,
} from "signoxe/components";
import { Box } from "signoxe/components/layout";
import PopupAside from "signoxe/components/PopupAside";
import PopupAsideCustom from "signoxe/components/PopupAsideCustom";
import { Header } from "signoxe/components/widgets";
import { NotificationPropType } from "signoxe/constants/propTypes";
import { AppRoutes, AuthRoutes } from "signoxe/containers";
import {
  getAuthState,
  getFetchingStatus,
  getHelpVisibility,
  getNotifications,
  getPageTitle,
  getUnreadNotificationCount,
  getUploads,
  getResumableUploads,
  getUploadTrayOpen,
  getProfile,
  getUploadState,
  getUploadVisibility,
  getFeatureStatus,
  getPreloadState,
} from "signoxe/selectors";

import "./styles.scss";

class Main extends React.Component {
  constructor(props) {
    super(props); // Always call super with props
    this.state = {
      showBanner: true, // Initialize showBanner state
    };
  }

  static propTypes = {
    children: PropTypes.element,
    uploads: PropTypes.array,
    resumableUploads: PropTypes.array,
    uploadTrayOpen: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    logoutUser: PropTypes.func.isRequired,
    toggleHelp: PropTypes.func.isRequired,
    toggleUploadsTray: PropTypes.func.isRequired,
    helpVisible: PropTypes.bool.isRequired,
    fetchAll: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    authState: PropTypes.shape({
      username: PropTypes.string,
      token: PropTypes.string,
      isLoggedIn: PropTypes.bool.isRequired,
      error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    }).isRequired,
    notifications: PropTypes.arrayOf(NotificationPropType).isRequired,
    unreadNotificationCount: PropTypes.number,
    markAllNotificationsRead: PropTypes.func.isRequired,
  };

  handleToggleUploadsTray = () => this.props.toggleUploadsTray();

  handleCloseBanner = () => {
    this.setState({ showBanner: false }); // Update state to hide the banner
  };

  componentDidUpdate(prevProps) {
    // Only update if the login status has changed
    if (!prevProps.authState.isLoggedIn && this.props.authState.isLoggedIn) {
      this.setState({ showBanner: true });
    }

    // if(this.props.next && this.props.next.length && !this.props.isFetching){
    //   console.log("asset prev props", prevProps.next, this.props.next);
    //   if (this.props.next.includes("/assets/?")){
    //     this.props.fetchPagedAssets(this.props.next);
    //   }
    // }
  }

  render() {
    const hostname = window.location.href;
    if (
      hostname.includes("/device-email-reports/") &&
      !this.props.authState.isLoggedIn
    ) {
      const slug = window.location.href.split("/device-email-reports/")[1];
      localStorage.setItem("device_report_slug", slug);
    }

    console.log("hostname", hostname);

    if (this.props.authState.isLoggedIn) {
      return this.renderApp();
    } else {
      return <AuthRoutes />;
    }
  }

  renderApp() {
    const reportNavItem = window.location.pathname.endsWith("/report");
    console.log("reportnav", reportNavItem);
    return (
      <Box direction="column" className="app-main">
        <Header
          mobile_logo={
            this.props.profile && this.props.profile.profile.mobile_logo
          }
          logo={this.props.profile && this.props.profile.profile.logo}
          title={this.props.title}
          username={this.props.authState.username}
          notifications={this.props.notifications}
          unreadNotificationCount={this.props.unreadNotificationCount}
          fetching={this.props.fetching}
          onMarkAllNotificationsRead={this.props.markAllNotificationsRead}
          onHelp={this.props.toggleHelp}
          onToggleUploadsTray={this.handleToggleUploadsTray}
          onLogout={this.props.logoutUser}
          profile={this.props.profile}
          onRefresh={this.props.fetchAll}
          isReportEnabled={this.props.isReportEnabled}
          reportNavActive={reportNavItem}
        />

        <Box
          direction="row"
          className="main-content"
          justifyContent="center"
          position="relative"
        >
          {/* {this.state.showBanner && (
            // <div
            //   style={{
            //     position: "absolute",
            //     width: "100%",
            //     zIndex: "999",
            //     display: "flex",
            //   }}
            // >
            <Banner handleCloseBanner={this.handleCloseBanner} />
            // </div>
          )} */}
          <div>
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </div>
        </Box>
        <BulkConfirmationPopup />
        <TagsPopup />
        <ConfirmationPopup />
        <PopupAside visible={this.props.helpVisible} title="Help">
          <HelpMessageRoutes />
        </PopupAside>
        <PopupAsideCustom
          toggleTray={this.props.toggleUploadsTray}
          visible={this.props.uploadTrayOpen}
          title="Uploads"
        >
          <UploadTray
            uploads={this.props.uploads}
            resumableUploads={this.props.resumableUploads}
            visible={this.props.uploadTypeOpen}
            toggleVisibility={this.props.toggleUploadType}
            toggleTray={this.props.toggleUploadsTray}
          />
        </PopupAsideCustom>
        {this.props.uploadDispatchVisible.visible ? (
          <UploadDispatch visible={this.props.uploadDispatchVisible.visible} />
        ) : (
          ""
        )}

        <Notifs
          componentClassName="notification-message"
          CustomComponent={NotificationMessage}
        />
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    uploads: getUploads(state),
    resumableUploads: getResumableUploads(state),
    uploadTrayOpen: getUploadTrayOpen(state),
    uploadTypeOpen: getUploadState(state),
    uploadDispatchVisible: getUploadVisibility(state),
    authState: getAuthState(state),
    profile: getProfile(state),
    title: getPageTitle(state),
    fetching: getFetchingStatus(state),
    helpVisible: getHelpVisibility(state),
    notifications: getNotifications(state),
    unreadNotificationCount: getUnreadNotificationCount(state),
    isReportEnabled: getFeatureStatus(state, "device_reporting"),
    next: getPreloadState(state),
    isFetching: state.assets.isFetching,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    logoutUser,
    toggleHelp,
    toggleUploadsTray,
    fetchAll,
    markAllNotificationsRead,
    toggleUploadType,
    getUploadVisibility,
    fetchPagedAssets,
  })(Main)
);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/Main/index.js